import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-comp-pro-wa-page-contents-main-footer',
	templateUrl:'./WaPageContentsMainFooterProPage.html',
	styles: [],
	styleUrls:['./WaPageContentsMainFooterProPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class WaPageContentsMainFooterProPage
{
	mdContent_386 = `\`\`\`java
import com.jwebmp.webawesome.components.page.WaPageContentsMainFooter;
\`\`\``;
	mdContent_387 = `\`\`\`java
new WaPageContentsMainFooter<>()
\`\`\``;
}
